module.exports = __webpack_public_path__ + "static/media/fries.1fe2ad01.jpg";